import feedback from '@/store/modules/feedback'
import inputLoading from '@/store/modules/input-loading'
import transcoHyperProxi from '@/store/modules/transco-hyper-proxi'
import suppliers from '@/store/modules/suppliers'

import Vue from 'vue'
import Vuex from 'vuex'
import { IRootStoreState } from '@/store/types'

import actions from '@/store/actions'
import getters from '@/store/getters'
import mutations from '@/store/mutations'
import nomenclatures from './modules/nomenclatures'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state: IRootStoreState = {
  user: undefined,
  parameters: undefined,
  isLoadingApp: true,
  globalError: undefined,
  isThereWorkToBeSaved: false,
  displayContirmRouteChangeDialog: false,
  pathToGoIfModalIsConfirmed: undefined,
  actionToHandleUnsavedWork: undefined,
}

const conf: any = {
  modules: {
    feedback: {
      namespaced: true,
      ...feedback,
    },
    transcoHyperProxi: {
      namespaced: true,
      ...transcoHyperProxi,
    },
    suppliers: {
      namespaced: true,
      ...suppliers,
    },
    nomenclatures: {
      namespaced: true,
      ...nomenclatures,
    },
    inputLoading,
  },
  state,
  getters,
  actions,
  mutations,
  strict: debug,
}

export default new Vuex.Store(conf)
